module.exports = __webpack_public_path__ + "resources/img/img_credit_event2.e56c47cf75e690c899a0fa0afb95e16d.png";